import { render, staticRenderFns } from "./ReportMobileFrame.vue?vue&type=template&id=4fde9587&scoped=true&"
import script from "./ReportMobileFrame.vue?vue&type=script&lang=js&"
export * from "./ReportMobileFrame.vue?vue&type=script&lang=js&"
import style0 from "./ReportMobileFrame.vue?vue&type=style&index=0&id=4fde9587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde9587",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
